import React from 'react';
import { FiExternalLink } from 'react-icons/fi';
import { ClickCard, DescriptionField, LinkFormProps, PasteLinkCard, SmallField, TitleField, useLinkForm } from './LinkCards';

// Add media coverage: a story about the company on another site, with an optional pull quote (spec 420:14055)
const CoverageForm: React.FC<LinkFormProps> = props => {
    const form = useLinkForm('coverage', props, 'tab');
    return <>
        <PasteLinkCard icon={<FiExternalLink />} form={form} placeholder="https://… the news story’s link">
            <TitleField value={props.title} onChange={props.onTitle} />
            <div className="fields three hub-news-fields">
                <SmallField label="Publication" hint="· shown under the title" value={form.fields[0]} onChange={v => form.setField(0, v)} />
                <SmallField label="Journalist" hint="(optional)" value={form.fields[1]} onChange={v => form.setField(1, v)} />
                <SmallField label="Date shown on website" value={form.fields[2]} onChange={v => form.setField(2, v)} />
            </div>
            <SmallField label="Pull quote" hint="(optional) · shown in bold on the card" value={form.quote} onChange={form.setQuote} />
            <DescriptionField value={form.description} onChange={form.setDescription} />
        </PasteLinkCard>
        <ClickCard form={form} newTab="Open the story in a new tab" />
    </>;
};

export default CoverageForm;
